function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "8FD813FD-21EC-4410-9C7D-DE8530A2B4A3");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Styleguide-+-UI-Components",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Styleguide",
  transform: "translate(-972.000000, -3056.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Cards/CardAction",
  transform: "translate(834.000000, 2950.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(16.000000, 106.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_arrow_right",
  transform: "translate(122.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  opacity: 0,
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2625011,5.26556709 L15.2898272,5.29289322 L15.2898272,5.29289322 L20.035,10.237 L20.0402664,10.232233 L20.7329846,10.9540148 C21.1043402,11.3409509 21.1043402,11.9519423 20.7329846,12.3388784 L20.7329846,12.3388784 L15.2898272,18.0104076 C15.2809066,18.0197025 15.271796,18.0288132 15.2625011,18.0377338 C14.8877018,18.3974413 14.2922664,18.3852069 13.9325589,18.0104076 L13.9325589,18.0104076 L13.9184748,17.9957327 C13.5471193,17.6087966 13.5471193,16.9978051 13.9184748,16.610869 L13.9184748,16.610869 L17.718,12.651 L4,12.6516504 C3.44771525,12.6516504 3,12.2039352 3,11.6516504 C3,11.0993657 3.44771525,10.6516504 4,10.6516504 L17.718,10.651 L13.9184748,6.69243181 C13.5471193,6.30549573 13.5471193,5.69450427 13.9184748,5.30756819 L13.9325589,5.29289322 C14.2922664,4.91809392 14.8877018,4.90585959 15.2625011,5.26556709 Z",
  id: "Combined-Shape"
}))))));

var SvgIconArrowRight = function SvgIconArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Arrow_Right.0296bb6c.svg";
export { ForwardRef as ReactComponent };